import React, { useContext } from 'react'
import styled from 'styled-components'
import { LayoutContext, useUI } from '../../contexts'
import Video from '../shared/Video'
import Accordion from '../shared/Accordion'

const TechnologyUsp = ({ uspVideo, uspSideVideo, upsAccordionItems }) => {
  const { node_locale, currency } = useContext(LayoutContext)

  return (
    <StyledUsp>
      {!!uspVideo.videoMp4 && !!uspSideVideo.videoWebm && !!uspVideo.poster && (
        <StyledVideo
          mp4={uspVideo.videoMp4.file.url}
          webm={uspVideo.videoWebm.file.url}
          poster={uspVideo.poster.fluid}
          controls
        />
      )}
      <Wrapper>
        <StyledAccordion
          useHtml
          items={upsAccordionItems.map(({ title, content }) => {
            return {
              title,
              content,
            }
          })}
          accordionTrackingData={{
            currency: currency?.code,
            locale: node_locale,
            viewType: 'Technology Page',
            sectionType: 'Technology USP',
          }}
        />
        <SideVideo
          mp4={uspSideVideo.videoMp4.file.url}
          webm={uspSideVideo.videoWebm.file.url}
          poster={uspSideVideo.poster.fluid}
          controls
        />
      </Wrapper>
    </StyledUsp>
  )
}

const StyledUsp = styled.section`
  background: ${(props) => props.theme.colors.lightGrey};
  overflow: hidden;
`

const StyledVideo = styled(Video)`
  position: relative;
  z-index: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vw;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    width: 100vw;
    height: auto;
  }
`

const StyledAccordion = styled(Accordion)`
  line-height: 4.8vw;
  letter-spacing: 0.05em;
  color: #20211a;
  margin-top: ${(props) => props.theme.space.marginMobile * 2}vw;
  padding-bottom: ${(props) => props.theme.space.marginMobile * 2}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    flex: 9;
    margin-top: 0;
    margin-bottom: 0;
    padding-bottom: 0;
    padding-top: ${(props) => props.theme.space.marginDesktop * 2}vw;
    line-height: 1.5277777778vw;
  }

  li {
    border-bottom: 1px solid #efedee;

    &:first-child {
      @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
        border-top: none;
      }
    }

    &:last-child {
      border-bottom: none;
    }
  }

  button {
    font-size: ${(props) => props.theme.fontSize.m35};
    position: relative;
    width: 100%;
    color: #20211a;
    line-height: 1.6;
    padding-right: ${(props) => props.theme.space.marginMobile * 6}vw;
    padding-left: ${(props) => props.theme.space.marginMobile * 4}vw;
    padding-top: ${(props) => props.theme.space.marginMobile * 2}vw;
    padding-bottom: ${(props) => props.theme.space.marginMobile * 2}vw;

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      font-size: ${(props) => props.theme.fontSize.d25};
      padding-right: ${(props) => props.theme.space.marginDesktop * 4}vw;
      padding-left: 0;
      padding-top: ${(props) => props.theme.space.marginDesktop * 4}vw;
      padding-bottom: ${(props) => props.theme.space.marginDesktop * 4}vw;
    }

    &::after {
      content: '';
      border: solid #20211a;
      border-width: 0 0.4vw 0.4vw 0;
      display: block;
      width: 0.8vw;
      height: 0.8vw;
      transform: rotate(45deg);
      position: absolute;
      right: ${(props) => props.theme.space.marginMobile * 4}vw;
      top: ${(props) => props.theme.space.marginMobile * 2.5}vw;

      @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
        border-width: 0 ${(props) => props.theme.space.marginDesktop / 5}vw
          ${(props) => props.theme.space.marginDesktop / 5}vw 0;
        width: ${(props) => props.theme.space.marginDesktop / 2}vw;
        height: ${(props) => props.theme.space.marginDesktop / 2}vw;
        right: ${(props) => props.theme.space.marginDesktop}vw;
        top: ${(props) => props.theme.space.marginDesktop * 5}vw;
      }
    }

    &.active::after {
      transform: rotate(-135deg);
    }
  }

  div {
    font-size: ${(props) => props.theme.fontSize.m23};
    padding-right: ${(props) => props.theme.space.marginMobile * 4}vw;
    padding-left: ${(props) => props.theme.space.marginMobile * 4}vw;
    padding-bottom: ${(props) => props.theme.space.marginMobile * 2}vw;

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      font-size: ${(props) => props.theme.fontSize.d14};
      padding-right: ${(props) => props.theme.space.marginDesktop * 4}vw;
      padding-left: 0;
      padding-bottom: ${(props) => props.theme.space.marginDesktop * 4}vw;
    }
  }
`

const SideVideo = styled(Video)`
  display: block;
  max-width: 50vw;
  margin: auto;
  margin-bottom: ${(props) => props.theme.space.marginMobile}vw;
  pointer-events: none;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    display: block;
    flex: 6;
    margin: ${(props) => props.theme.space.marginDesktop}vw
      ${(props) => props.theme.space.marginDesktop * 4}vw;
  }
`

const Wrapper = styled.div`
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    display: flex;
    padding: ${(props) => props.theme.space.marginDesktop * 16}vw
      ${(props) => props.theme.space.marginDesktop * 16}vw;
  }
`

export default TechnologyUsp
